import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import ChangePasswordModal from "./ChangePasswordModal";
import CodeModal from "./CodeModal";
import LayoutWrapper from "./LayoutWrapper";
import UserProfileModal from "./UserProfileModal";

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      viewMode: false,
      editMode: false,
      popupfields: {},
      popupdata: {},
      //
      editDataProfile: {},
      viewModeProfile: false,
      editModeProfile: false,
      popupfieldsProfile: {},
      popupdataProfile: {},
      //
      editDataPassword: {},
      viewModePassword: false,
      editModePassword: false,
      popupfieldsPassword: {},
      popupdataPassword: {},
      loader: false,
    };
    this.modalFields = [
      {
        type: "text",
        name: "code",
        label: "Code",
        customcolspan: "col-12",
        required: true,
      },
    ];
    this.profileFields = [
      {
        type: "text",
        name: "child_name",
        label: "Child Name",
        required: true,
        customcolspan: "col-12",
      },
      {
        type: "select",
        name: "grade",
        label: "Grade",
        options: [],
        required: true,
        customcolspan: "col-12",
      },
      {
        type: "text",
        name: "school_name",
        label: "School Name",
        required: true,
        customcolspan: "col-12",
      },
      {
        type: "text",
        name: "school_city",
        label: "School City",
        required: true,
        customcolspan: "col-12",
      },
    ];
    this.passwordFields = [
      {
        type: "text",
        name: "old_password",
        label: "Old Password",
        required: true,
        customcolspan: "col-12",
      },
      {
        type: "text",
        name: "new_password",
        label: "New Password",
        required: true,
        customcolspan: "col-12",
      },
      {
        type: "text",
        name: "confirm_password",
        label: "Confirm Password",
        required: true,
        customcolspan: "col-12",
      },
    ];
    this.codeModalRef = React.createRef();
    this.profileModalRef = React.createRef();
    this.changePasswordModalRef = React.createRef();
  }

  componentDidMount() {
    let isProfileUpdateSkipped =
      window.store.getState().root.isProfileUpdateSkipped;
    let isTempPass = window.store.getState().root.user.temp_pass;
    let loginData = window.store.getState().root.user;
    // console.log({ isProfileUpdateSkipped, loginData });

    if (isProfileUpdateSkipped === undefined) {
      this.props.setstore("isProfileUpdateSkipped", false);
    }

    setTimeout(() => {
      if (isProfileUpdateSkipped === false) {
        this.getGrades();
        document.querySelector("#user_profile_modal .btn.close-btn").innerText =
          "skip";
      }

      if (isTempPass) {
        this.changePasswordModalRef.current.click();
      }
    }, 500);
  }

  getGrades() {
    this.props.api.apiGetCurriculumGrades().then((res) => {
      let gradeOpts = res.data?.options("curriculum_grade", "curriculum_grade");
      if (res) {
        this.profileFields = this.profileFields?.map((item) => {
          if (item?.name === "grade") {
            return {
              ...item,
              options: gradeOpts,
            };
          } else {
            return item;
          }
        });
        this.profileModalRef.current.click();
      }
    });
  }
  addModalFields() {
    let fields = this.modalFields.reduce((o, n) => ({ ...o, [n.name]: n }), {});
    let formdata = Object.map(fields, (v, k) => "");
    this.setState({
      popupfields: fields,
      popupdata: formdata,
    });
  }
  addProfileModalFields() {
    let fields = this.profileFields.reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    this.setState({
      popupfieldsProfile: fields,
      popupdataProfile: formdata,
    });
  }

  openCodeModal() {
    this.codeModalRef.current.click();
  }
  closeModal() {
    document.querySelector("#code_modal #bsmodalclose").click();
  }
  closeProfileModal() {
    document.querySelector("#user_profile_modal #bsmodalclose").click();
  }
  closeChangePasswordModal() {
    document.querySelector("#change_password_modal #bsmodalclose").click();
  }

  // ----------------------------------------------------------------

  addChangePasswordModalFields() {
    let fields = this.passwordFields.reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    this.setState({
      popupfieldsPassword: fields,
      popupdataPassword: formdata,
    });
  }

  handleSubmit(event, data, form) {
    event.preventDefault();

    this.setState({
      loader: true,
    });

    const resolveList = (res) => {
      toast.success(`Code added successfully`, {
        autoClose: 3000,
        closeButton: false,
        hideProgressBar: true,
      });
      form.reset();
      this.closeModal();
      navigate(
        `/mycontent/sessions?packageId=${res?.data?.package?.package_id}&packageName=${res?.data?.package?.package_name}`
      );
    };
    let payload = {
      qrcode_id: data?.code,
    };
    this.props.api
      .apiScanQRcode(payload)
      .then((res) => {
        resolveList(res);
        this.setState({
          loader: false,
        });
      })
      .catch((error) => {
        this.setState({
          loader: false,
        });
      });
  }

  handleProfileSubmit(event, data, form) {
    event.preventDefault();

    this.setState({
      loader: true,
    });

    const resolveList = () => {
      toast.success(`Profile updated successfully`, {
        autoClose: 3000,
        closeButton: false,
        hideProgressBar: true,
      });
      form.reset();
      this.closeProfileModal();
    };
    let updatePayload = {
      ...data,
    };

    console.log({ updatePayload });

    this.props.api
      .apiUpdateB2cUser(updatePayload)
      .then((res) => {
        this.setState({
          loader: false,
        });
        resolveList();
      })
      .catch((err) => {
        this.setState({
          loader: false,
        });
      });
  }

  handleChangePasswordSubmit(e, data, form) {
    event.preventDefault();

    // this.setState({
    //   loader: true,
    // });
    let payload = {};

    if (data.new_password.localeCompare(data.confirm_password) == 0) {
      payload = {
        old_password: data.old_password,
        new_password: data.new_password,
      };
      this.props.api
        .apiCustomerChangePassword(payload)
        .then((res) => {
          this.props.api.applogout();
          success("Password Changes Successfully");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      alert("Confirm Password is not same as New Password");
    }
  }
  render() {
    let { navigate } = this.props;
    let {
      editData,
      popupdata,
      popupfields,
      viewMode,
      loader,
      editDataProfile,
      viewModeProfile,
      popupfieldsProfile,
      popupdataProfile,
      //
      editDataPassword,
      viewModePassword,
      popupfieldsPassword,
      popupdataPassword,
    } = this.state;
    return (
      <>
        {loader && (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        )}
        <LayoutWrapper
          title={`Hello ${
            window.store.getState().root?.user?.child_name ||
            window.store.getState().root?.user?.full_name
          }`}
          back=""
        >
          <ToastContainer position="top-right" />
          <div className="row">
            <div
              className="col-12 col-md-4 cursor-pointer"
              onClick={() => {
                document
                  .querySelector('[data-bs-target="#code_modal"]')
                  .click();
              }}
            >
              <div className="home_card">
                <img
                  src={imagepaths.homeImg1}
                  className="img-fluid"
                  alt="image"
                />
                <div className="action">
                  <h2 className="">Enter Code</h2>
                  <button
                    className="btn btn-success btn-block hidden"
                    ref={this.codeModalRef}
                    data-bs-toggle="modal"
                    data-bs-target="#code_modal"
                    onClick={(...args) => this.addModalFields(...args)}
                  >
                    Click Here!
                  </button>
                </div>
              </div>
            </div>
            <div
              className="col-12 col-md-4 cursor-pointer"
              onClick={(...args) => navigate("/allcontent")}
            >
              <div className="home_card">
                <img
                  src={imagepaths.homeImg2}
                  className="img-fluid"
                  alt="image"
                />
                <div className="action">
                  <h2 className="">Buy Content</h2>
                </div>
              </div>
            </div>
            <div
              className="col-12 col-md-4 cursor-pointer"
              onClick={(...args) => navigate("/mycontent")}
            >
              <div className="home_card">
                <img
                  src={imagepaths.homeImg3}
                  className="img-fluid"
                  alt="image"
                />
                <div className="action">
                  <h2 className="">My Content</h2>
                </div>
              </div>
            </div>
          </div>

          <CodeModal
            id="code_modal"
            title="Enter Code"
            submitText="Submit"
            editdata={editData}
            data={popupdata}
            fields={popupfields}
            disableallfields={viewMode ? true : false}
            submitButton={viewMode ? false : true}
            closeButton={viewMode ? true : false}
            onSubmit={(...args) => this.handleSubmit(...args)}
            onClose={() =>
              this.setState({
                popupdata: {},
                editData: {},
                editMode: false,
                viewMode: false,
              })
            }
          />

          <button
            className="btn btn-success btn-block hidden"
            ref={this.profileModalRef}
            data-bs-toggle="modal"
            data-bs-target="#user_profile_modal"
            onClick={(...args) => this.addProfileModalFields(...args)}
          >
            Click Here!
          </button>

          <UserProfileModal
            id="user_profile_modal"
            title="Just a little more! Fill in the fields below to proceed."
            submitText="Submit"
            editdata={editDataProfile}
            data={popupdataProfile}
            fields={popupfieldsProfile}
            disableallfields={viewModeProfile ? true : false}
            submitButton={viewModeProfile ? false : true}
            closeButton={viewModeProfile ? true : false}
            onSubmit={(...args) => this.handleProfileSubmit(...args)}
            onClose={() => {
              this.props.setstore("isProfileUpdateSkipped", true);
              this.setState({
                popupdataProfile: {},
                editDataProfile: {},
                editModeProfile: false,
                viewModeProfile: false,
              });
            }}
          />

          <button
            className="btn btn-success btn-block hidden"
            ref={this.changePasswordModalRef}
            data-bs-toggle="modal"
            data-bs-target="#change_password_modal"
            onClick={(...args) => this.addChangePasswordModalFields(...args)}
          >
            Click Here!
          </button>

          <ChangePasswordModal
            id="change_password_modal"
            title="Change Password"
            submitText="Change Password"
            editdata={editDataPassword}
            data={popupdataPassword}
            fields={popupfieldsPassword}
            disableallfields={viewModePassword ? true : false}
            submitButton={viewModePassword ? false : true}
            closeButton={viewModePassword ? true : false}
            onSubmit={(...args) => this.handleChangePasswordSubmit(...args)}
            onClose={() => {
              this.props.setstore("isProfileUpdateSkipped", true);
              this.setState({
                popupdataPassword: {},
                editDataPassword: {},
                editModePassword: false,
                viewModePassword: false,
              });
            }}
          />
        </LayoutWrapper>
      </>
    );
  }
}

export default connect(Dashboard);
